<template>
  <v-container fluid v-if="tiene_empresa">
    <v-data-table :headers="headers" :items="items">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('configuration-table-top-t1') }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="listarSucursales()" v-bind="attrs" v-on="on">
                fa-solid fa-rotate-right
              </v-icon>
            </template>
            <span>{{ $t('btn-update') }}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-autocomplete v-model="sucursal" :items="items_sucursales" item-text="nombre"
            :label="$t('configuration-table-top-t2')" outlined dense hide-details return-object
            @input="listarPuntosVenta()" class="px-1"></v-autocomplete>
          <v-autocomplete v-model="punto_venta" :items="items_puntos_venta" item-text="descripcion"
            :label="$t('configuration-table-top-t3')" outlined dense hide-details return-object class="px-1"
            @input="listarConfiguraciones()"></v-autocomplete>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="nuevaConfi()">{{ $t('configuration-table-btn1') }}</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action_edit`]="{ item }">
        <v-icon @click="verDetalles(item)"> fa-solid fa-pen-to-square </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" width="1000" persistent>
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table v-model="tipo_doc_fiscales_seleccionados" :headers="headers_tipo_docs"
                :items="items_tipo_docs" item-key="cod_doc_fiscal" show-select>
                <template v-slot:[`item.correlativo`]="{ item }">
                  <v-edit-dialog :return-value.sync="item.correlativo">
                    {{ item.correlativo }}
                    <template v-slot:input>
                      <v-text-field v-model="item.correlativo" label="Editar" single-line></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="guardarConfi()">{{ $t('btn-save') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialog()">{{ $t('btn-close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_editar" width="500" persistent>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="cod" label="Código" outlined dense hide-details readonly></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="tipo_doc" label="Tipo Doc." outlined dense hide-details readonly></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="correlativo" label="Correlativo" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_editar = false">{{ $t('btn-close') }}</v-btn>
          <v-btn color="primary" @click="actualizarConfi()">{{ $t('btn-update') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="8000" color="blue" multi-line elevation="24" outlined top right>
      <v-icon>{{ icon_snackbar }}</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    dialog: false,
    snackbar: false,
    snackbar_text: "Mensaje",
    icon_snackbar: "fa-solid fa-circle-info",
    items: [],
    sucursal: "",
    items_sucursales: [],
    punto_venta: "",
    items_puntos_venta: [],
    //TIPO DOCS FISCALES

    items_tipo_docs: [],
    tipo_doc_fiscales_seleccionados: [],
    dialog_editar: false,
    id_confi_factura: 0,
    cod: "",
    tipo_doc: "",
    correlativo: "",
  }),
  created() {
    //
  },
  computed: {

    headers() {
      return [
        { text: this.$t("configuration-table-header1-t1"), value: "cod_doc_fiscal" },
        { text: this.$t("configuration-table-header1-t2"), value: "nombre_doc_fiscal" },
        { text: this.$t("configuration-table-header1-t3"), value: "correlativo" },
        { text: this.$t("configuration-table-header1-t4"), value: "action_edit" },
      ]
    },

    headers_tipo_docs() {
      return [
        { text: this.$t("configuration-header2-t1"), value: "cod_doc_fiscal" },
        { text: this.$t("configuration-header2-t2"), value: "nombre" },
        { text: this.$t("configuration-header2-t3"), value: "correlativo" },
      ]
    },

    tiene_empresa() {
      if (this.$store.state.emp) {
        this.listarSucursales();
        return true;
      }
    },
  },
  methods: {
    listarConfiguraciones() {
      axios
        .get(
          "api/ConfiFacturas/Listar/" +
          this.sucursal.id_sucursal +
          "/" +
          this.punto_venta.id_punto_venta +
          "/" +
          this.$store.state.emp.id_empresa
        )
        .then((response) => {
          //console.log(response.data);
          this.items = response.data;
        });
    },
    listarSucursales() {
      axios
        .get("api/Sucursales/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_sucursales = response.data;
          this.sucursal = response.data[0];
          this.listarPuntosVenta();
        });
    },
    listarPuntosVenta() {
      axios
        .get("api/PuntoVentas/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_puntos_venta = response.data;
          this.punto_venta = response.data[0];
          this.listarConfiguraciones();
        });
    },
    listarTipoDocFiscales() {
      axios.get("api/TipoDocFiscales/Listar").then((response) => {
        this.items_tipo_docs = response.data;
      });
    },
    nuevaConfi() {
      this.dialog = true;

      this.listarTipoDocFiscales();
    },
    guardarConfi() {
      this.tipo_doc_fiscales_seleccionados.forEach((element) => {
        axios.post("api/ConfiFacturas/Crear", {
          id_sucursal: this.sucursal.id_sucursal,
          id_punto_venta: this.punto_venta.id_punto_venta,
          id_tipo_doc_fiscal: element.id_tipo_doc_fiscal,
          id_empresa: this.$store.state.emp.id_empresa,
          correlativo: element.correlativo,
        });
      });
      this.cerrarDialog();

      this.snackbar_text = this.$t('configuration-snackbar-t1');
      this.snackbar = true;
    },
    actualizarConfi() {
      axios
        .put("api/ConfiFacturas/ActualizarCorrelativo", {
          id_confi_factura: this.id_confi_factura,
          correlativo: this.correlativo,
        })
        .then(() => {
          this.cerrarDialogEditar();
          this.listarConfiguraciones();

          this.snackbar_text = this.$t('configuration-snackbar-t2');
          this.snackbar = true;
        });
    },
    cerrarDialog() {
      this.dialog = false;

      this.limpiar();
    },
    verDetalles(item) {
      this.id_confi_factura = item.id_confi_factura;
      this.cod = item.cod_doc_fiscal;
      this.tipo_doc = item.nombre_doc_fiscal;
      this.correlativo = item.correlativo;

      this.dialog_editar = true;
    },
    cerrarDialogEditar() {
      this.dialog_editar = false;

      this.id_confi_factura = 0;
      this.cod = "";
      this.tipo_doc = "";
      this.correlativo = "";
    },
    limpiar() {
      this.tipo_doc_fiscales_seleccionados = [];
      this.items_tipo_docs = [];
    },
  },
};
</script>